exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title {\n  font-weight: 600; }\n\n.card.p-3.d-flex {\n  width: 1148px !important;\n  margin-left: 15px; }\n\n.status {\n  border: 1px solid;\n  border-radius: 4px;\n  padding: 2px; }\n\n.PendingConfirmation {\n  color: white;\n  border-color: orange;\n  background-color: orange; }\n\n.Active {\n  color: white;\n  border-color: green;\n  background-color: green; }\n\n.Inactive {\n  color: white;\n  border-color: black;\n  background-color: black; }\n\n.Decline {\n  color: white;\n  border-color: red;\n  background-color: red; }\n\n.New {\n  color: white;\n  border-color: blue;\n  background-color: blue; }\n\nimg {\n  width: 70px;\n  margin-right: 0.5rem;\n  border-radius: 4px; }\n\n.show-all {\n  text-decoration: underline;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/pages/free-hotel-changes/free-hotel-changes.component.scss
// module id = ../../../../../src/app/main/pages/free-hotel-changes/free-hotel-changes.component.scss
// module chunks = main